import { isSameDay } from 'date-fns';
import { HabitSchedule } from 'shared/types/habit-schedule';
import { Timestamp } from 'shared/types/timestamp';

export type Options = {
  fullyCompleted?: boolean;
};

export const getScheduleCompletedOnDate = (
  schedule: HabitSchedule,
  date: Timestamp,
  { fullyCompleted }: Options = {},
) => {
  const completedOnDay = schedule.entries?.find(
    (entry) =>
      entry.state === 'complete' &&
      !!entry.value &&
      isSameDay(entry.date, date),
  );

  if (schedule.frequency) {
    return (
      !!completedOnDay &&
      (completedOnDay.value ?? 0) >= schedule.completionTarget.count
    );
  }

  return (
    !!completedOnDay &&
    (!fullyCompleted ||
      (completedOnDay.value ?? 0) >= schedule.completionTarget.count)
  );
};
